import axios from "axios";

const baseUrl = "https://hacker-news.firebaseio.com/v0/";
//const newStoriesUrl = `${baseUrl}newstories.json`;
const topStoriesUrl = `${baseUrl}topstories.json`;
const storyUrl = `${baseUrl}item/`;

export const getStoryIds = async () => {
  //const result = await axios.get(newStoriesUrl);
  const result = await axios.get(topStoriesUrl);

  let offlineStoryIds =
    JSON.parse(localStorage.getItem("offlineStoryIds")) || [];
  offlineStoryIds = result.data;
  window.localStorage.setItem(
    "offlineStoryIds",
    JSON.stringify(offlineStoryIds)
  );

  return result.data;
};

export const getStory = async (storyId) => {
  const result = await axios.get(`${storyUrl + storyId}.json`);

  let offlineStories = JSON.parse(localStorage.getItem("offlineStories")) || [];
  // Ideally we don't want to overload the stories we save in localStorage
  if (offlineStories.length > 400) {
    offlineStories = [];
  }
  offlineStories.push(result.data);
  window.localStorage.setItem("offlineStories", JSON.stringify(offlineStories));

  return result.data;
};

export const getOfflineStoryIds = async () => {
  return JSON.parse(localStorage.getItem("offlineStoryIds")) || [];
};

export const getOfflineStory = async (storyId) => {
  const allOfflineStories =
    JSON.parse(localStorage.getItem("offlineStories")) || [];
  const story = allOfflineStories.find((obj) => obj.id === storyId);

  return story;
};
